@if (init$ | async) {
    <div>
        <priva-loader [hasFooter]="true">
            <priva-spinner />
            <ng-container data-footer>{{ 'LOADING.TITLE.LOADING_CONTAINERS' | translate }}</ng-container>
        </priva-loader>
    </div>
} @else {
    <div class="container-list">
        @if (containers().length) {
            <priva-table
                class="container-table container-list__viewport"
                [rows]="containers()"
                [disableSelect]="true"
                type="separate"
                [hasHeader]="false"
                (rowClick)="onContainerClick($event.row)"
                data-test="container-table"
            >
                <ng-template priva-table-column="Name" let-item="row"> {{ item.name }}</ng-template>
                @if (showRemove()) {
                    <ng-template priva-table-column="" alignment="end" let-item="row">
                        <i
                            class="fa-solid fa-trash-can"
                            (click)="onRemoveContainerClick(item)"
                            data-test="remove-container-btn"
                        ></i>
                    </ng-template>
                }
            </priva-table>
        } @else {
            <priva-notification>{{ 'ERROR.TITLE.NO_CONTAINER_FOUND' | translate }}</priva-notification>
        }
    </div>
}
